var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.666 24.5733H17.3327L11.3993 28.52C10.5193 29.1067 9.33268 28.48 9.33268 27.4133V24.5733C5.33268 24.5733 2.66602 21.9067 2.66602 17.9067V9.90666C2.66602 5.90666 5.33268 3.23999 9.33268 3.23999H22.666C26.666 3.23999 29.3327 5.90666 29.3327 9.90666V17.9067C29.3327 21.9067 26.666 24.5733 22.666 24.5733Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 16.1467C15.4537 16.1467 15.0004 15.6934 15.0004 15.1467V14.8668C15.0004 13.3201 16.1337 12.5601 16.5604 12.2668C17.0537 11.9334 17.2137 11.7068 17.2137 11.3601C17.2137 10.6934 16.6671 10.1467 16.0004 10.1467C15.3337 10.1467 14.7871 10.6934 14.7871 11.3601C14.7871 11.9068 14.3338 12.3601 13.7871 12.3601C13.2404 12.3601 12.7871 11.9068 12.7871 11.3601C12.7871 9.58677 14.2271 8.14673 16.0004 8.14673C17.7737 8.14673 19.2137 9.58677 19.2137 11.3601C19.2137 12.8801 18.0938 13.6401 17.6804 13.9201C17.1604 14.2668 17.0004 14.4934 17.0004 14.8668V15.1467C17.0004 15.7067 16.5471 16.1467 16.0004 16.1467Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.4666C15.44 19.4666 15 19.0132 15 18.4666C15 17.9199 15.4533 17.4666 16 17.4666C16.5467 17.4666 17 17.9199 17 18.4666C17 19.0132 16.56 19.4666 16 19.4666Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.3ee22d0ea8e28937e9c2a82c222aa8e1.svg";
export { ForwardRef as ReactComponent };